/* ==========================================================================
   growies – Affiliate-Landingpage
   Gemeinsames Script für alle sections/affiliate-*.liquid Dateien.
   Steuert das dezente Fade-in/Slide-up beim Scrollen (CI §8), inkl.
   Stagger-Effekt für wiederholte Elemente (Karten, Listenpunkte).
   Datei NICHT umbenennen – wird von allen affiliate-Sections per
   asset_url eingebunden. Läuft sicher auch, wenn mehrere Sections das
   Script mehrfach einbinden (idempotent).
   ========================================================================== */
(function () {
  if (window.__growiesAffiliateRevealInit) return;
  window.__growiesAffiliateRevealInit = true;

  function initRevealGroup(group) {
    var items = group.querySelectorAll('.ga-reveal');
    if (!items.length) return;

    var prefersReduced = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('ga-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var index = Array.prototype.indexOf.call(items, el);
          var delay = Math.min(index, 6) * 90;
          setTimeout(function () {
            el.classList.add('ga-in-view');
          }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    document.querySelectorAll('[data-ga-reveal-group]').forEach(initRevealGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when a section is (re)loaded/added.
  document.addEventListener('shopify:section:load', function (event) {
    var group = event.target.querySelector('[data-ga-reveal-group]');
    if (group) initRevealGroup(group);
  });
})();
